import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyPointsComponent } from './mypoints.component'
import { TransactionsSummaryComponent } from './transactions-summary/transactions-summary.component';

const routes: Routes = [
    { path: '', component: MyPointsComponent },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyPointsRoutingModule { }
